import React from "react";
const ErrorMarker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.627"
      height="22.627"
      viewBox="0 0 22.627 22.627"
    >
      <g
        id="Group_3309"
        data-name="Group 3309"
        transform="translate(906.504 -2248.958) rotate(45)"
      >
        <path
          id="Path_1960"
          data-name="Path 1960"
          d="M29.5,16.423a8,8,0,1,0-8,8,8,8,0,0,0,8-8"
          transform="translate(943.758 2214.825)"
          fill="#c00051"
        />
        <path
          id="Path_1961"
          data-name="Path 1961"
          d="M7.61,6.54,4.833,3.8,7.575,1.023,6.541,0,3.8,2.777,1.023.035,0,1.071,2.775,3.812.035,6.588,1.069,7.61,3.811,4.833,6.588,7.575Z"
          transform="translate(965.259 2225.867) rotate(45)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default ErrorMarker;
